<template>
    <!-- 消息通知 -->
    <div  class="Booking">
    <TopNavigation  class="topNavigation"></TopNavigation>
        <div class="typeArea">
            <div class="content">
                <div class="title">
                    消息通知
                </div>
                <el-tabs v-model="activeName">
                    <el-tab-pane label="系统通知" name="first">
                        <template #label>
                            <el-badge is-dot :hidden="hiddenSysBadge">
                                <span>系统通知</span>
                            </el-badge>
                        </template>
                        <el-empty v-if="systemTotal==0" description="暂无通知"></el-empty>
                        <div v-else>
                            <div 
                                v-for="item in systemList"
                                class="sys-msg" 
                                :key="item.id"
                                @click="SysDetail(item.id)"
                            >
                                <div class="zuo">
                                    <div>
                                        <span :class="item.read == 0 ? '' : 'yanse'"></span>
                                        {{item.title}}
                                    </div>
                                    <div class="date">
                                        {{item.create_time}}
                                    </div>
                                </div>
                                <div class="chakn">
                                    <span>去查看</span>
                                    <i class="el-icon-arrow-right"></i>
                                </div>
                            </div>
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="systemForm.page_no"
                                :page-sizes="[10, 20, 30, 40]"
                                :page-size="systemForm.page_size"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="systemTotal">
                            </el-pagination>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="订舱通知" name="seconnd">
                        <template #label>
                            <el-badge is-dot :hidden="hiddenDcBadge">
                                <span>订舱通知</span>
                            </el-badge>
                        </template>
                        <el-empty v-if="orderTotal==0" description="暂无通知"></el-empty>
                        <div v-else>
                            <div 
                                v-for="item in orderList"
                                class="sys-msg" 
                                :key="item.id"
                                @click="SysDetail(item.id)"
                            >
                                <div class="zuo">
                                    <div>
                                        <span :class="item.read == 0 ? '' : 'yanse'"></span>
                                        {{item.title}}
                                    </div>
                                    <div class="date">
                                        {{item.create_time}}
                                    </div>
                                </div>
                                <div class="chakn">
                                    <span>去查看</span>
                                    <i class="el-icon-arrow-right"></i>
                                </div>
                            </div>
                            <el-pagination
                                @size-change="handleOrderSizeChange"
                                @current-change="handleOrderCurrentChange"
                                :current-page="orderForm.page_no"
                                :page-sizes="[10, 20, 30, 40]"
                                :page-size="orderForm.page_size"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="orderTotal">
                            </el-pagination>
                        </div>
                    </el-tab-pane>
                    <!-- 留言记录 -->
                    <el-tab-pane label="舱位留言" name="third">
                        <template #label>
                            <el-badge is-dot :hidden="hiddenCabinBadge">
                                <span>舱位留言</span>
                            </el-badge>
                        </template>
                        <el-empty v-if="cabinTotal==0" description="暂无通知"></el-empty>
                        <div v-else>
                            <div 
                                v-for="item in cabinList"
                                class="sys-msg" 
                                :key="item.id"
                                @click="cabinDetail(item.id)"
                            >
                                <div class="zuo">
                                    <div>
                                        <div class="txhz">
                                            <span :class="item.user_unread > 0 ? '' : 'yanse'"></span>
                                            <div>起运港：{{item.pol_name}}</div>
                                            <div>目的港：{{item.pod_name}}</div>
                                            <div>箱型港：{{item.box_quantity_desc}}</div>
                                        </div>
                                        <!-- <div class="txhz">
                                            <span class="yanse"></span>
                                            <div>留言内容：{{item.content}}</div>
                                        </div> -->
                                    </div>
                                    <div class="date">
                                        {{item.create_time}}
                                    </div>
                                </div>
                                <div class="chakn">
                                    <span>去查看</span>
                                    <i class="el-icon-arrow-right"></i>
                                </div>
                            </div>
                            <el-pagination
                                @size-change="handleCabinSizeChange"
                                @current-change="handleCabinCurrentChange"
                                :current-page="cabinForm.page_no"
                                :page-sizes="[10, 20, 30, 40]"
                                :page-size="cabinForm.page_size"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="cabinTotal">
                            </el-pagination>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="美加留言" name="fourth">
                        <template #label>
                            <el-badge is-dot :hidden="hiddenMjdmBadge">
                                <span>美加留言</span>
                            </el-badge>
                        </template>
                        <el-empty v-if="mjdmTotal==0" description="暂无通知"></el-empty>
                        <div v-else>
                            <div 
                                v-for="item in mjdmList"
                                class="sys-msg" 
                                :key="item.id"
                                @click="mjdmDetail(item.id)"
                            >
                                <div class="zuo">
                                    <div class="txhz">
                                        <span :class="item.user_unread > 0 ? '' : 'yanse'"></span>
                                        <div>国家：{{item.country_name}}</div>
                                        <div>送达城市(邮编)：{{item.end_city_name}}</div>
                                        <div>卸货港/卸货地：{{item.port_name}}</div>
                                        <div>进出口类型：{{item.type_desc}}</div>
                                    </div>
                                    <div class="date">
                                        {{item.create_time}}
                                    </div>
                                </div>
                                <div class="chakn">
                                    <span>去查看</span>
                                    <i class="el-icon-arrow-right"></i>
                                </div>
                            </div>
                            <el-pagination
                                @size-change="handleMjdmSizeChange"
                                @current-change="handleMjdmCurrentChange"
                                :current-page="mjdmForm.page_no"
                                :page-sizes="[10, 20, 30, 40]"
                                :page-size="mjdmForm.page_size"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="mjdmTotal">
                            </el-pagination>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    <Bottom />
    </div>
</template>
    
<script>
import { userNoticeLists,unReadNum,cabinReplyList,mjdmReplyList } from "@/api/api";
import Bottom from '../HP/BottomPage.vue';
import TopNavigation from "../HP/TopNavigationB.vue";
export default {
    components:{
        Bottom,
        TopNavigation,
    },
    data() {
        return {
            activeName: 'first',
            systemForm:{
                type:1, // 1-系统通知 2-短信通知（订舱）
                page_no:1,
                page_size:10,
            },
            orderForm:{
                type:2, // 1-系统通知 2-短信通知（订舱）
                page_no:1,
                page_size:10,
            },
            headers: {
                token: localStorage.getItem("token"),
            },

            cabinForm:{
                pol_id:'',
                pod_id:'',
                start_time:'',
                end_time:'',
                page_no:1,
                page_size:10,
            },
            mjdmForm:{
                page_no:1,
                page_size:10,
            },

            systemList:[],
            systemTotal:0,
            orderList:[],
            orderTotal:0,
            cabinList:[],
            cabinTotal:0,
            mjdmList:[],
            mjdmTotal:0,
            // 是否显示未读留言
            hiddenSysBadge:true,
            hiddenDcBadge:true,
            hiddenCabinBadge:true,
            hiddenMjdmBadge:true,
        }
    },
    methods: {
        handleSizeChange(val){
            this.systemForm.page_size=val
            this.getSystemList()
        },
        handleCurrentChange(val){
            this.systemForm.page_no=val
            this.getSystemList()
        },
        SysDetail(index){
            this.$router.push({
                name:'MessageDetail',
                query:{
                    id:index
                }
            })
            this.getUnReadNum()
        },
        async getSystemList(){
            this.hiddenSysBadge=true
            try {
                const res = await userNoticeLists(this.systemForm,this.headers)
                if(res.code==1){
                    this.systemList = res.data.lists
                    this.systemTotal = res.data.count
                    for (let i = 0; i < this.systemList.length; i++) {
                       if ( this.systemList[i].read==0) {
                        this.hiddenSysBadge=false
                       }
                    }
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        handleOrderSizeChange(val){
            this.orderForm.page_size=val
            this.getOrderList()
        },
        handleOrderCurrentChange(val){
            this.orderForm.page_no=val
            this.getOrderList()
        },
        async getOrderList(){
            this.hiddenDcBadge=true
            try {
                const res = await userNoticeLists(this.orderForm,this.headers)
                if(res.code==1){
                    this.orderList = res.data.lists
                    this.orderTotal = res.data.count
                    for (let i = 0; i < this.orderList.length; i++) {
                       if ( this.orderList[i].read == 0) {
                            this.hiddenDcBadge=false
                       }
                    }
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        // 调用接口  获取未读数量
        async getUnReadNum(){
            try {
                const res = await unReadNum({token:localStorage.getItem('token')})
                let storedObject = localStorage.getItem('userInfo');
                if (storedObject) { 
                    let obj = JSON.parse(storedObject);
                    obj.unread_num = res.data.unread_num;
                    localStorage.setItem('userInfo', JSON.stringify(obj)); // 重新存储对象
                    // location.reload()  // 修改本地存储  刷新页面
                }      
            } catch (error) {
                console.log(error,'失败');
            }
        },
        handleCabinSizeChange(val){
            this.cabinForm.page_size=val
            this.getCabinist()
        },
        handleCabinCurrentChange(val){
            this.cabinForm.page_no=val
            this.getCabinist()
        },
        cabinDetail(index){
            this.$router.push({
                name:'MessageRecordDetail',
                query:{
                    type:1,
                    id:index
                }
            })
            this.getUnReadNum()
        },
        async getCabinist(){
            this.hiddenCabinBadge=true
            try {
                const res = await cabinReplyList(this.cabinForm,this.headers)
                if(res.code==1){
                    this.cabinList = res.data.lists
                    this.cabinTotal = res.data.count
                    for (let i = 0; i < this.cabinList.length; i++) {
                        if (this.cabinList[i].user_unread>0) {
                            this.hiddenCabinBadge=false
                        }
                    }
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
        handleMjdmSizeChange(val){
            this.mjdmForm.page_size=val
            this.getMjdmList()
        },
        handleMjdmCurrentChange(val){
            this.mjdmForm.page_no=val
            this.getMjdmList()
        },
        mjdmDetail(index){
            this.$router.push({
                name:'MessageRecordDetail',
                query:{
                    type:2,
                    id:index
                }
            })
            this.getUnReadNum()
        },
        async getMjdmList(){
            this.hiddenMjdmBadge=true
            
            try {
                const res = await mjdmReplyList(this.mjdmForm,this.headers)
                if(res.code==1){
                    this.mjdmList = res.data.lists
                    this.mjdmTotal = res.data.count
                    for (let i = 0; i < this.mjdmList.length; i++) {
                        if (this.mjdmList[i].user_unread>0) {
                            this.hiddenMjdmBadge=false
                        }
                    }
                }
            } catch (error) {
                console.log(error,'失败');
            }
        },
    },
    mounted(){
        this.getSystemList()
        this.getOrderList()
        this.getUnReadNum()
        this.getCabinist()
        this.getMjdmList()
    }
}
</script>
    
<style style lang="scss" scoped>
.topNavigation{
    height: 100PX;
    display: flex;
    justify-content: space-between;
    padding: 0 80px;
    background: #fff;
}

.Booking{
    background: #F9F9F9;
}
.typeArea{
    width: 1200px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
}

.content{
    margin-top: 20px;
    margin-bottom: 29px;
    background: #FFFFFF;
    border-radius: 12px 12px 12px 12px;
    // height: 680px;
    overflow: auto;
    padding: 32px;
    box-sizing: border-box;

    .title{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        font-style: normal;
        text-transform: none;

        margin-bottom: 10px;
    }

    ::v-deep .el-tabs__item.is-active {
        color: #0073F5;//选中
    }
    
    ::v-deep .el-tabs__item:hover {
        color: #0073F5;//hover
        // cursor: pointer;
    }
    // 普通字体颜色
    ::v-deep .el-tabs__item {
        color: #606260;//悬浮
        // cursor: pointer;
        font-size: 18px;
    }

    // 下划线颜色
    ::v-deep .el-tabs__active-bar {
        background-color: #0073F5;
    }

    .sys-msg{
        height: 98px;
        border-bottom: 1px solid #eee;

        display: flex;
        justify-content: center;
        flex-direction: column;

        cursor: pointer;

        .zuo{
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #333333;
            font-style: normal;
            text-transform: none;
            display: flex;
            align-items: center;
            justify-content: space-between;
            span{
                display: inline-block;
                width: 8px;
                height: 8px;
                background: #FF3F3F;
                border-radius: 50%;
                margin-right: 7px;
            }

            div{
                margin-right: 12px;
                // margin-bottom: 8px;
            }
            .yanse{
                background: none;
            }
            .date{
                font-size: 14px;
                color: #333333;
            }
        }

        .chakn{
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #999999;
            font-style: normal;
            text-transform: none;

            margin-left: 18px;
            margin-top: 8px;
        }
    }
}

.el-pagination{
    text-align: right;
    margin-top: 32px;
}

:deep(.el-badge){
    .el-badge__content.is-fixed.is-dot {
        right: 0px;
        top: 8px;
    }
}

.txhz{
    display: flex;
    align-items: center;
}
</style>